import { StyleSheet } from 'aphrodite/no-important';
import { imageStyleSheet, AspectRatio } from './image.types';

const calculateImageUrl: (host: string, path: string, manipulation?: string) => string = (host, path, manipulation?) => `${host + manipulation}/${path}`;

const smallWidth = '372';
const mediumHWidth = '688';
export const largeWidth = '912';

export const getSrcSet = (aspectRatio: AspectRatio, host: string, path: string) => ({
  small: calculateImageUrl(host, path, `c_fill,w_${smallWidth},ar_${aspectRatio.x}:${aspectRatio.y},f_auto,q_auto,g_auto`),
  medium: calculateImageUrl(host, path, `c_fill,w_${mediumHWidth},ar_${aspectRatio.x}:${aspectRatio.y},f_auto,q_auto,g_auto`),
  large: calculateImageUrl(host, path, `c_fill,w_${largeWidth},ar_${aspectRatio.x}:${aspectRatio.y},f_auto,q_auto,g_auto`),
  lowResUrl: calculateImageUrl(host, path, `c_fill,w_16,ar_${aspectRatio.x}:${aspectRatio.y},f_auto,q_auto,g_auto`),
});

const getSrcSetAttributeValue = (small: string, medium: string, large: string) => {
  return `${small} 300w, ${medium} 600w, ${large} 900w`;
};

export const getMinWidthBySize = (size: string) => {
  switch (size) {
    case 'small': return '(min-width: 300px)';
    case 'medium': return '(min-width: 600px)';
    case 'large': return '(min-width: 900px)';
    default: return '';
  }
};

export const imageStyle = StyleSheet.create({
  base: {
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    minWidth: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    transition: 'opacity 0.2s ease-in-out',
    willChange: 'opacity, transform',
    objectFit: 'cover',
    minHeight: '100%',
  },
}) as imageStyleSheet;

export const getCalculatedThumbnail = (aspectRatio: AspectRatio, description: string, host: string, path: string) => {
  const { small, medium, lowResUrl, large } = getSrcSet(aspectRatio, host, path);
  return {
    imageUrl: medium,
    lowResUrl,
    alt: description,
    title: description,
    srcSet: getSrcSetAttributeValue(small, medium, large),
    sizes: '(max-width: 300px) 300px,(max-width: 600px) 600px,(min-width: 600px) 900px',
  };
};

export const getImageCaption = (credit: string | undefined, caption: string | undefined): string => {
  return [caption, credit].filter(value => {
    return typeof value === 'string' && value.trim() !== '';
  }).join(' | ');
};
